import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';
import Image from '../../../Core/Image';

export const StyledContainer = styled(Container)`
  margin-top: 0;
  margin-bottom: 0;
  max-width: unset;
  width: 100%;
`;

export const OfferBanner = styled.div`
  display: flex;
  width: 100%;
  height: 100px;
  justify-content: center;
  background-color: ${props =>
    props.backgroundColor
      ? themeGet(`colors.${props.backgroundColor}`)
      : 'transparent'};
`;

export const StyledImage = styled(Image)`
  max-width: 280px;
  width: 100%;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-width: 350px;
  }
`;
